import Constants from '~/app/Constants';
import Configuration from './Configuration';

export function requestIsFromMobile(queryParams: URLSearchParams): boolean {
  const clientID = queryParams.get(Constants.UrlParameters.clientID);

  if (clientID && clientID === Configuration.Current().mobileClientID) {
    sessionStorage.setItem('mobileDeviceMode', 'true');
    return true;
  }

  return false;
}
